@if (hierarchyMode) {
  <form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
    <div [class.dropdown-label-left]="!labelTop">
      @if (!hideLabel) {
        <label for="companyID-field" class="form-label">Company</label>
      }
      <div class="company-select-wrap">
        <ng-select
          appendTo="body"
          bindLabel="description"
          bindValue="id"
          class="company-clean"
          [clearable]="false"
          formControlName="companyID"
          id="companyID-field"
          [items]="viewData"
          panelClass="dd-tall"
          [placeholder]="firstCompanyOption || ''"
          [searchable]="true"
          [virtualScroll]="false"
          (change)="selectOnChange($event)"
          (search)="onSearch($event)"
        >
  
          <ng-template ng-label-tmp let-item="item">
            {{ cleanName(item?.description) }}
          </ng-template>
  
          <ng-template ng-option-tmp let-item="item">
            {{ item?.description }}
            <span
              class="reseller-caret"
              *ngIf="isResellerRow(item)"
              (click)="toggleReseller(item, $event)"
              [title]="isCollapsed(item) ? 'Expand' : 'Collapse'">
              {{ isCollapsed(item) ? '▸' : '▾' }}
            </span>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </form>
} @else {
  <form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
    <div [class.dropdown-label-left]="!labelTop">
      @if (!hideLabel) {
        <label for="companyID-field" class="form-label">Company</label>
      }
      <ng-select
        appendTo="body"
        bindLabel="description"
        bindValue="id"
        [clearable]="selectAllOption"
        formControlName="companyID"
        id="companyID-field"
        [items]="viewData"
        [placeholder]="firstCompanyOption || ''"
        [searchable]="true"
        (change)="selectOnChange($event)"
      ></ng-select>
    </div>
  </form>
}
